function e(e, r) {
  for (var t = r.length, n = 0; n < t; n++) {
    if (null == e) return;
    e = e[r[n]];
  }
  return t ? e : void 0;
}
export { e as default };